import { Button, HSpacer, Text } from '@/components/DesignSystem';
import {
  ProgramExclusionsBottomSheet,
} from '@/pages/CustomerDashboard/ProgramExclusionsBottomSheet';
import { ApiCategory } from '@api/interfaces';
import { Stack } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface ProgramExclusionsDisclaimerProps {
  brandColor: string,
  categories: ApiCategory[],
  segmentSpendCategoryExclusionIds: string[],
  tierSpendCategoryExclusionIds: string[],
}

export const ProgramExclusionsDisclaimer = ({
  brandColor,
  categories,
  segmentSpendCategoryExclusionIds,
  tierSpendCategoryExclusionIds,
}: ProgramExclusionsDisclaimerProps) => {
  const { t } = useTranslation();
  const [showCategoryExclusions, setShowCategoryExclusions] = useState(false);
  return (
    <Stack direction="row" justifyContent="space-between">
      <Stack>
        <Text category="label-medium">
          {t($ => $.customerDashboard.programExclusions.title)}
        </Text>
        <Text category="body-xsmall" sx={{ color: '#525252' }}>
          {t($ => $.customerDashboard.programExclusions.disclaimer)}
        </Text>
      </Stack>
      <HSpacer size="4" />
      <Button
        onClick={() => setShowCategoryExclusions(true)}
        sx={{ color: brandColor }}
        testID="program-exclusions-detail-button"
        variant="text"
      >
        {t($ => $.common.actions.details)}
      </Button>
      {showCategoryExclusions && (
        <ProgramExclusionsBottomSheet
          categories={categories}
          onClose={() => setShowCategoryExclusions(false)}
          segmentSpendCategoryExclusionIds={segmentSpendCategoryExclusionIds}
          tierSpendCategoryExclusionIds={tierSpendCategoryExclusionIds}
        />
      )}
    </Stack>
  );
};
